module.exports = " <link v-el:link v-if=cookie.theme rel=stylesheet :href=cookie.theme id=page-theme> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeadCss.vue
 ** module id = 225
 ** module chunks = 2
 **/